function handleHeaderHover() {
  const headerWrapper = document.querySelector('.header-wrapper');
  const headerNavigation = headerWrapper?.querySelector('[data-nav]');
  const headerNavigationItems = headerWrapper?.querySelectorAll('[data-nav] > li');
  const defaultVariables = getVariables(headerWrapper);

  headerNavigationItems.forEach(navItem => {
    const variables = getItemVariables(navItem.dataset.handle);
    const hasMenu = navItem.dataset.hasMenu === 'true' ? true : false;

    if (hasMenu) {
      navItem.addEventListener('mouseenter', updatesVariables.bind(this, headerWrapper, variables));

      navItem.addEventListener('mouseleave', resetVariables.bind(this, headerWrapper, defaultVariables));
    }
  });
}

function updatesVariables(header, variables) {
  if (variables['featured_color']) {
    header.style.setProperty('--megamenu-background', variables['featured_color']);
  }

  if (variables['items_color']) {
    header.style.setProperty('--header-hover-color', variables['items_color']);
  }

  if (variables['featured_color'] && variables['appllies_color'] === 'header') {
    header.style.setProperty('--header-hover-background', variables['featured_color']);

    header.classList.add('header-wrapper--change-background', `header-wrapper--items-color-${variables['items_color']}`);
  }

  header.classList.add('header-wrapper--hover');
}

function resetVariables(header, variables) {
  for (const [key, value] of Object.entries(variables)) {
    header.style.setProperty(key, value);
  }

  header.classList.remove('header-wrapper--hover', 'header-wrapper--change-background', 'header-wrapper--items-color-white', 'header-wrapper--items-color-black');
}

function getVariables(element) {
  const variables = {};
  const propertiesArray = Array.from(element.style).filter((key) => key.startsWith('--'));

  propertiesArray.forEach(propertyName => {
    variables[propertyName] = element.style.getPropertyValue(propertyName);
  })

  return variables;
}

function getItemVariables(handle) {
  const variables = {};
  const getCSSProp = (element, propertyName) => getComputedStyle(element).getPropertyValue(propertyName);

  variables['featured_color'] = getCSSProp(document.documentElement, `--nav-color-${handle}`);
  variables['appllies_color'] = getCSSProp(document.documentElement, `--nav-applies-color-${handle}`);
  variables['items_color'] = getCSSProp(document.documentElement, `--nav-items-color-${handle}`);

  return variables;
}

document.addEventListener('DOMContentLoaded', handleHeaderHover);
